import { render, staticRenderFns } from "./customerAcountDetail_goodsDetail.vue?vue&type=template&id=50245119&scoped=true&"
import script from "./customerAcountDetail_goodsDetail.vue?vue&type=script&lang=js&"
export * from "./customerAcountDetail_goodsDetail.vue?vue&type=script&lang=js&"
import style0 from "./customerAcountDetail_goodsDetail.vue?vue&type=style&index=0&id=50245119&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50245119",
  null
  
)

export default component.exports